import { render, staticRenderFns } from "./ThankYouMobile.vue?vue&type=template&id=8cd5bf82"
import script from "./ThankYouMobile.vue?vue&type=script&lang=js"
export * from "./ThankYouMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports